import {get,post} from '../index'
export const getMall={
    getList(params){
        return get('/category/list',params)
    },
    getGoods(params){
        return get('/goods/list',params)
    },
    getDetails(params){
        return get('/goods/detail',params)
    }
}


// WEBPACK FOOTER //
// ./src/api/http/mall.js